import iconFrontendMentor from "/src/assets/images/icon-frontend-mentor.svg";
import iconGithub from "/src/assets/images/icon-github.svg";
import iconLinkedin from "/src/assets/images/icon-linkedin.svg";
import iconTwitter from "/src/assets/images/icon-twitter.svg";

let socialIcons = [
  { src: iconGithub, name: "Github" },
  { src: iconFrontendMentor, name: "Frontend Mentor" },
  { src: iconLinkedin, name: "Linkedin" },
  { src: iconTwitter, name: "Twitter" },
];

export default socialIcons;
